import { render, staticRenderFns } from "./InstrumentPerformanceView.vue?vue&type=template&id=4fe1b5f6&scoped=true"
import script from "./InstrumentPerformanceView.vue?vue&type=script&lang=ts"
export * from "./InstrumentPerformanceView.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentPerformanceView.vue?vue&type=style&index=0&id=4fe1b5f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe1b5f6",
  null
  
)

export default component.exports